/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkPackageAnalyzedImageDtoPage } from '../../models/work-package-analyzed-image-dto-page';

export interface ListAnalyzedImages$Params {
  projectId: string;
  storageObjectIds?: Array<string>;
  name?: string;
  type?: string;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'tenantId' | '-tenantId' | 'name' | '-name' | 'dynamicFormsValue' | '-dynamicFormsValue'>;
}

export function listAnalyzedImages(http: HttpClient, rootUrl: string, params: ListAnalyzedImages$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackageAnalyzedImageDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listAnalyzedImages.PATH, 'get');
  if (params) {
    rb.query('projectId', params.projectId, {});
    rb.query('storageObjectIds', params.storageObjectIds, {});
    rb.query('name', params.name, {});
    rb.query('type', params.type, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkPackageAnalyzedImageDtoPage>;
    })
  );
}

listAnalyzedImages.PATH = '/v0/FocoosAI/analyzed-images';
